import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import AccountClient from '../apiClients/AccountClient';
import useViewportMode from '../hooks/useViewportMode';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CreatedOrganization = () => {
    const { mode: viewportMode, isPhone, isDesktop } = useViewportMode();

    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const query = useQuery();
    const idToken = query.get("id_token");

    const handleGotoDashboard = () => {

    }

    const createOrg = async () => {
        try {
            var context = { 
                FirstName: "firstName",
                LastName: "lastName",
                Email: "email",
                Password: "password",
                OrganizationName: "Wont need this",
                Positions: ['AccountingProfessional']
            }

            var orgId = await new AccountClient().CreateOrganization(context);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (!isAuthenticated)
            return;


    });

    return (
        <AuthenticatedTemplate>
            {isDesktop ? <>
                <Typography className="h1">Success! Your new organization is being created!</Typography>
                {/* <Button onClick={handleGotoDashboard}>Goto Dashboard</Button> */}
                <Button onClick={createOrg}>Finish Create Org</Button>
            </> : <Box
                data-viewport-mode={viewportMode}
                sx={{
                    minHeight: '100vh',
                    '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    overflowY: 'auto',
                    px: isPhone ? 1.5 : 3,
                    pt: isPhone ? 2 : 4,
                    pb: 'calc(16px + env(safe-area-inset-bottom, 0px))',
                }}>
                <Paper variant="outlined" sx={{ width: '100%', maxWidth: 680, p: isPhone ? 2 : 3 }}>
                    <Stack spacing={2.5}>
                        <Typography variant={isPhone ? 'h4' : 'h3'}>Success! Your new organization is being created!</Typography>
                        <Button variant="contained" onClick={createOrg} sx={{ minHeight: 44, width: isPhone ? '100%' : 'fit-content', alignSelf: isPhone ? 'stretch' : 'flex-end' }}>
                            Finish Create Org
                        </Button>
                    </Stack>
                </Paper>
            </Box>}
        </AuthenticatedTemplate>
    );
}

export default CreatedOrganization;
